export default __webpack_public_path__ + "static/media/backtotop.69dac38b.svg";